import Checkbox from './Checkbox'
import CheckboxGroup from './CheckboxGroup'

import withField, { withValidationFields } from '../withField'

const CheckboxField = withField(Checkbox)
const CheckboxWithValidation = withValidationFields(Checkbox)
const CheckboxGroupField = withField(CheckboxGroup)
const CheckboxGroupWithValidation = withValidationFields(CheckboxGroup)

export {
  Checkbox,
  CheckboxField,
  CheckboxWithValidation,
  CheckboxGroup,
  CheckboxGroupField,
  CheckboxGroupWithValidation,
}
